<template>
  <v-row dense>
    <v-col cols="12" md="12">
      <v-breadcrumbs v-if="!loading && !loadingBreadcrumb" class="pt-0 pl-0 sub-header font-weight-bold color-blue">
        <router-link to="/dashboard/help_center">
          <v-breadcrumbs-item>
            Help Center
          </v-breadcrumbs-item>
        </router-link>
        <v-breadcrumbs-item>
          <v-icon>mdi-chevron-right</v-icon>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item>
          {{topic.name}}   
        </v-breadcrumbs-item>
      </v-breadcrumbs>
      <div v-else class="mb-5" style="width: 25%;">
        <v-skeleton-loader transition="scale-transition" type="text"></v-skeleton-loader>
      </div>
      <v-card :height="cardHeight">
        <v-row style="height: inherit" dense>
          <v-col style="height: 100%;" v-if="articles.length > 0" cols="12" sm="4" class="p-2 pl-4 pt-4">
            <v-list class="py-0" dense>
              <div v-for="i in limit" v-show="loading || loadingArticleList">
                <v-skeleton-loader transition="scale-transition" type="text" class="p-2"></v-skeleton-loader>
              </div>
                <v-list-item-group v-model="list" v-if="articles.length > 0 && !loading && !loadingArticleList">
                  <template v-for="(article, index) in articles">
                    <router-link :to="{ name: 'ArticleDetail', params:{id: article.sys.id} }">
                      <v-list-item @click="openArticle(article.sys.id)" :key="article.sys.id">
                        <v-list-item-content>
                          <v-list-item-title class="text color-black" v-text="article.fields.title"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </router-link>
                    <v-divider v-if="index + 1 < articles.length" :key="index" class="m-1"></v-divider>
                  </template>
                </v-list-item-group>
                <div v-if="articles.length === 0 && !loading">
                  <span class="color-grey text">No Articles</span>
                </div>
              </v-list>
          </v-col>
          <v-col style="height: 100%;" cols="12" sm="8" class="p-4 pt-4">
            <div v-show="loading || loadingArticle">
              <v-skeleton-loader transition="scale-transition" type="article"></v-skeleton-loader>
              <v-skeleton-loader transition="scale-transition" type="image" class="px-4"></v-skeleton-loader>
            </div>
            <div style="height: 100%; overflow-y: auto;" v-if="selectedArticle !== null" v-show="!loading && !loadingArticle">
              <div id="articleTitle" class="font-weight-bold color-blue h5 mb-4">{{selectedArticle.fields.title}}</div>
              <div v-if="selectedArticle.fields.content">
                <RichTextRenderer :document="selectedArticle.fields.content" :nodeRenderers="renderNodes()"/>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from 'vuex'
import RichTextRenderer from 'contentful-rich-text-vue-renderer'
import { BLOCKS } from '@contentful/rich-text-types'
import ContentfulImage from './contentful-image.vue'

export default {
  data: () => ({
    loading: true,
    limit: 10,
    list: 0,
  }),
  components: {
    ContentfulImage,
    RichTextRenderer,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props,
          },
        }, children)
      },
    },
  },
  computed: {
    ...mapGetters([
      'selectedArticle',
      'articles',
      'topic',
      'loadingArticle',
      'loadingArticleList',
      'loadingBreadcrumb'
    ]),
    cardHeight: function() {
      return this.$screen.height * 60/100
    },
  },
  created() {
    this.$store.dispatch('getEntry', this.$route.params.id).then(() => {
      this.list = this.articles.findIndex(article => article.sys.id === this.selectedArticle.sys.id)
      this.loading = false
    })     
  },
  methods: {
    openArticle(articleId) {
      this.$store.commit('setLoadingArticle', true)
      this.$store.dispatch('getArticle', articleId)
    },
    renderNodes() {
      return {
        [BLOCKS.EMBEDDED_ASSET]: (node, key, h) => {
          let width = node.data.target.fields.file.details.image.width
          let height = node.data.target.fields.file.details.image.height
          let url = node.data.target.fields.file.url
          let image = `<img style="height:${height}; width:${width}" src="${url}">`

          return h('ContentfulImage', { key: key, props: {image: image}})
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .v-list-item--active{
    background-color: rgba(145,212,244,0.3);
  }
  .v-list {
    height: 100%;
    overflow-y: auto;
  }
</style>
